import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './share_campaign.less'
import { getI18n } from 'client/i18n'
import CopyBox from 'components/common/copy_box'

/* eslint-disable import/no-unresolved */
import Facebook from '!!babel-loader!react-svg-loader!images/facebook.svg'
import Messenger from '!!babel-loader!react-svg-loader!images/messenger.svg'
import Twitter from '!!babel-loader!react-svg-loader!images/twitter.svg'
import WhatsApp from '!!babel-loader!react-svg-loader!images/whatsapp.svg'

/* eslint-enable import/no-unresolved */

import {
  shareURLByFacebook,
  shareURLByMessenger,
  shareByTwitter,
  shareByWhatsApp,
} from 'consumerweb-sharing'

const i18n = getI18n('components/share')

class ShareCampaign extends React.Component {
  static propTypes = {
    shareUrl: PropTypes.string.isRequired,
    displayUrl: PropTypes.string.isRequired,
    shareable: PropTypes.bool.isRequired,
    appId: PropTypes.number.isRequired,

    onClickOverride: PropTypes.func,

    showFacebook: PropTypes.bool,
    showMessenger: PropTypes.bool,
    showTwitter: PropTypes.bool,
    showWhatsApp: PropTypes.bool,
  }

  static defaultProps = {
    shareable: true,
    showFacebook: true,
    showMessenger: true,
    showTwitter: true,
    showWhatsApp: true,
  }

  handleIconClick = (socialNetwork, event) => {
    if (this.props.onClickOverride) {
      this.props.onClickOverride(event)
      if (event.isDefaultPrevented()) {
        return
      }
    }

    switch (socialNetwork) {
      case 'facebook':
        shareURLByFacebook(this.props.shareUrl, 640, 480)
        break

      case 'messenger':
        shareURLByMessenger(
          this.props.shareUrl,
          this.props.appId,
          window.location.href
        )
        break

      case 'twitter':
        shareByTwitter(this.props.shareUrl, 640, 480)
        break

      case 'whats-app':
        shareByWhatsApp(this.props.shareUrl)
        break

      default:
        break
    }
  }

  render() {
    let shareText = this.props.displayUrl
    if (!this.props.shareable) {
      shareText = i18n('link_placeholder')
    }

    return (
      <div>
        <CopyBox
          text={shareText}
          copyText={this.props.shareUrl}
          enabled={this.props.shareable}
        />
        <div styleName="share-icons">
          {this.props.showFacebook && (
            <div
              styleName="share-icon"
              data-pa-click="shareFacebook"
              onClick={this.handleIconClick.bind(this, 'facebook')}
            >
              <Facebook />
              <div styleName="sub-text">{i18n('facebook')}</div>
            </div>
          )}

          {this.props.showMessenger && (
            <div
              styleName="share-icon"
              data-pa-click="shareMessenger"
              onClick={this.handleIconClick.bind(this, 'messenger')}
            >
              <Messenger />
              <div styleName="sub-text">{i18n('messenger')}</div>
            </div>
          )}

          {this.props.showTwitter && (
            <div
              styleName="share-icon"
              data-pa-click="shareTwitter"
              onClick={this.handleIconClick.bind(this, 'twitter')}
            >
              <Twitter />
              <div styleName="sub-text">{i18n('twitter')}</div>
            </div>
          )}

          {this.props.showWhatsApp && (
            <div
              styleName="share-icon"
              data-pa-click="shareWhatsApp"
              onClick={this.handleIconClick.bind(this, 'whats-app')}
            >
              <WhatsApp />
              <div styleName="sub-text">{i18n('whatsapp')}</div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default cssModules(ShareCampaign, styles)
